import React, { useState } from 'react';
import { X, AlertTriangle } from 'lucide-react';
import api from '../../services/api';

export default function DeleteConfirmModal({ isOpen, onClose, onSuccess, poste }) {
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    setLoading(true);
    try {
      await api.delete(`/postes/${poste.ID_Postes}`);
      onSuccess();
      onClose();
    } catch (err) {
      console.error('Erreur suppression:', err);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen || !poste) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-3">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-sm">
        <div className="flex justify-between items-center p-3 border-b">
          <h3 className="text-sm font-semibold text-gray-800">Confirmer la suppression</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <X size={16} />
          </button>
        </div>
        
        <div className="p-4 text-center">
          <AlertTriangle className="mx-auto mb-3 text-red-500" size={40} />
          <p className="text-sm text-gray-600 mb-1">Voulez-vous vraiment supprimer ce poste ?</p>
          <p className="text-sm font-semibold text-gray-800 mb-1">{poste.Nom_Postes}</p>
          <p className="text-xs text-gray-400">Cette action est irréversible.</p>
        </div>
        
        <div className="flex gap-2 p-3 border-t">
          <button
            onClick={onClose}
            className="flex-1 px-3 py-1.5 border border-gray-200 rounded text-xs text-gray-600 hover:bg-gray-50"
          >
            Annuler
          </button>
          <button
            onClick={handleDelete}
            disabled={loading}
            className="flex-1 px-3 py-1.5 bg-red-500 hover:bg-red-600 text-white rounded text-xs font-medium disabled:opacity-50"
          >
            {loading ? 'Suppression...' : 'Supprimer'}
          </button>
        </div>
      </div>
    </div>
  );
}